/*
 * Mermaid's Magic Sea Moss — Core Theme JavaScript
 * Modules: Scroll Reveal, Animated Counter, FAQ Accordion, Sticky Header, Video Play/Pause
 * Vanilla JS only. No dependencies.
 */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Module 1: Scroll Reveal Observer ── */
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

  document.querySelectorAll('[data-reveal], .reveal').forEach(function (el) {
    // Skip elements that have data-count — the counter observer handles those
    if (el.hasAttribute('data-count')) return;
    revealObserver.observe(el);
  });

  /* ── Module 2: Animated Counter ── */
  var counterObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      counterObserver.unobserve(el);

      // Make the element visible (handles the reveal transition)
      el.classList.add('is-visible');

      var numberEl = el.querySelector('[data-count-number]');
      if (!numberEl) return;

      var target = parseFloat(el.getAttribute('data-count')) || 0;
      var dec = parseInt(el.getAttribute('data-dec'), 10) || 0;
      var duration = 1400;
      var start = 0;

      function tick(now) {
        if (!start) start = now;
        var progress = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 4);
        var value = eased * target;
        numberEl.textContent = dec > 0 ? value.toFixed(dec) : Math.round(value).toString();
        if (progress < 1) requestAnimationFrame(tick);
      }

      requestAnimationFrame(tick);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -30px 0px' });

  document.querySelectorAll('[data-count]').forEach(function (el) {
    counterObserver.observe(el);
  });

  /* ── Module 3: FAQ Accordion Toggle ── */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-faq-toggle]');
    if (!toggle) return;

    var item = toggle.closest('[data-faq-item]');
    if (!item) return;

    var answer = item.querySelector('[data-faq-answer]');
    var isOpen = toggle.classList.contains('is-open');

    // Close all open FAQs
    document.querySelectorAll('[data-faq-toggle].is-open').forEach(function (t) {
      t.classList.remove('is-open');
      t.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('[data-faq-answer].is-open').forEach(function (a) {
      a.classList.remove('is-open');
    });

    // Toggle the clicked one (open if it was closed)
    if (!isOpen) {
      toggle.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      if (answer) answer.classList.add('is-open');
    }
  });

  /* ── Module 4: Sticky Header ── */
  var header = document.querySelector('[data-header]');
  if (header) {
    var hero = document.querySelector('[data-hero]');
    if (hero) {
      /* Only toggle on pages with a dark hero section */
      var threshold = hero.offsetHeight - 80;
      window.addEventListener('scroll', function () {
        header.classList.toggle('is-scrolled', window.scrollY > threshold);
      }, { passive: true });
    }
    /* Pages without hero keep is-scrolled class from server-side rendering */
  }

  /* ── Module 5: Mobile Drawer Toggle ── */
  var drawerToggle = document.querySelector('[data-drawer-toggle]');
  var drawer = document.querySelector('[data-drawer]');
  var drawerClose = document.querySelector('[data-drawer-close]');
  var drawerOverlay = document.querySelector('[data-drawer-overlay]');

  function openDrawer() {
    if (drawer) drawer.classList.add('is-open');
    if (drawerOverlay) drawerOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (drawer) drawer.classList.remove('is-open');
    if (drawerOverlay) drawerOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (drawerToggle) drawerToggle.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  /* ── Module 6: Video Play/Pause ── */
  document.addEventListener('click', function (e) {
    var wrapper = e.target.closest('[data-video-toggle]');
    if (!wrapper) return;

    var video = wrapper.querySelector('video');
    if (!video) return;

    var playBtn = wrapper.querySelector('[data-play-btn]');

    if (video.paused) {
      // Pause all other videos and reset their play buttons
      document.querySelectorAll('[data-video-toggle] video').forEach(function (v) {
        if (v !== video) {
          v.pause();
          var btn = v.closest('[data-video-toggle]').querySelector('[data-play-btn]');
          if (btn) btn.style.opacity = '1';
        }
      });
      video.play().then(function() {
        video.muted = false;
      }).catch(function() {
        video.muted = true;
        video.play().catch(function() {});
      });
      if (playBtn) playBtn.style.opacity = '0';
    } else {
      video.pause();
      if (playBtn) playBtn.style.opacity = '1';
    }
  });

});
